import { Star, Quote } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { site } from "@/config/site";

interface Review {
  name: string;
  bezirk: string;
  rating: number;
  textDe: string;
  textEn: string;
  service: string;
  date: string;
}

const reviews: Review[] = [
  { name: "Anna B.", bezirk: "1010 Innere Stadt", rating: 5, service: "Türöffnung", date: "2026-03",
    textDe: "Sonntagabend ausgesperrt – Techniker war in 12 Minuten da, Tür ohne Beschädigung geöffnet, Festpreis wie am Telefon. Top!",
    textEn: "Locked out on Sunday evening – technician arrived in 12 minutes, opened the door without damage, fixed price as quoted. Excellent!" },
  { name: "Markus W.", bezirk: "1070 Neubau", rating: 5, service: "Schlosswechsel", date: "2026-02",
    textDe: "Nach Einbruch sofort EVVA-Schloss montiert. Sehr professionell, sauber gearbeitet, faire Preise.",
    textEn: "EVVA lock installed immediately after burglary. Very professional, clean work, fair prices." },
  { name: "Elena K.", bezirk: "1100 Favoriten", rating: 5, service: "Notdienst", date: "2026-01",
    textDe: "Schlüssel im Schloss abgebrochen – um 23 Uhr angerufen, 20 Min später war alles erledigt. Sehr empfehlenswert.",
    textEn: "Key broke in the lock – called at 11pm, all sorted 20 min later. Highly recommended." },
  { name: "Stefan H.", bezirk: "1030 Landstraße", rating: 5, service: "Zylinderwechsel", date: "2025-12",
    textDe: "Transparente Beratung, Preis vorab klar kommuniziert. Kein Vergleich zu den schwarzen Schafen der Branche.",
    textEn: "Transparent advice, price clearly communicated upfront. No comparison to the cowboys in the industry." },
  { name: "Julia M.", bezirk: "1190 Döbling", rating: 5, service: "Türöffnung", date: "2025-11",
    textDe: "Freundlich, schnell, preiswert. Habe schon mehrfach empfohlen – immer zufriedene Rückmeldung.",
    textEn: "Friendly, fast, affordable. Have recommended many times – always positive feedback." },
  { name: "Thomas R.", bezirk: "1210 Floridsdorf", rating: 5, service: "Einbruchschutz", date: "2025-10",
    textDe: "Beratung und Einbau Sicherheitstür – kompetent, ehrlich, perfektes Ergebnis. Kann ich nur weiterempfehlen.",
    textEn: "Consultation and installation of security door – competent, honest, perfect result. Highly recommend." },
];

export const Reviews = () => {
  const { lang } = useLang();
  return (
    <section id="reviews" className="py-20 md:py-28 bg-secondary">
      <div className="container">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-accent font-semibold uppercase tracking-widest text-sm">
            {lang === "de" ? "Bewertungen" : "Reviews"}
          </span>
          <h2 className="font-display text-4xl md:text-6xl text-primary mt-3 mb-4">
            {lang === "de" ? "Was unsere Kunden sagen" : "What our customers say"}
          </h2>
          <div className="flex items-center justify-center gap-3">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-6 h-6 fill-accent text-accent" />
              ))}
            </div>
            <span className="font-semibold text-primary text-lg">{site.rating} / 5</span>
            <span className="text-muted-foreground">
              ({site.reviewCount.toLocaleString("de-AT")} {lang === "de" ? "Bewertungen" : "reviews"})
            </span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <article key={i} className="bg-card border border-border rounded-2xl p-6 shadow-card-soft hover:shadow-elegant transition-smooth relative">
              <Quote className="absolute top-5 right-5 w-8 h-8 text-accent/15" />
              <div className="flex mb-3">
                {[...Array(r.rating)].map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-accent text-accent" />
                ))}
              </div>
              <p className="text-foreground/85 leading-relaxed mb-5 text-[15px]">
                "{lang === "de" ? r.textDe : r.textEn}"
              </p>
              <div className="border-t border-border pt-4">
                <div className="font-semibold text-primary">{r.name}</div>
                <div className="text-xs text-muted-foreground">{r.bezirk} · {r.service}</div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
